function Resources() {}
export default Resources;
